import { Typography, TypographyProps } from "@mui/material";
import * as React from "react";

type Props = Omit<TypographyProps, "variant" | "gutterBottom" | "component" | "color" | "sx" | "margin"> & { margin?: MprcMargin; };

export const MprcBarTitle: React.FC<Props> = (props) => {
    const { children, margin = "normal" } = props;
    return (
        <Typography
            variant="h2"
            gutterBottom
            component="div"
            color="muted"
            noWrap
            marginX={margin == "normal" ? 1 : margin == "dense" ? .5 : 0}
            marginBottom={0}
        >
            {children}
        </Typography>
    );
};
